
import React, { useState } from "react";
import { Input, Button, Select } from "antd";
import { useTranslation } from "react-i18next";
const { Option } = Select;


const MoveProductsModal = ({ open, onClose, selectedProducts, groups, onSave, }) => {
      const { t, i18n } = useTranslation();
    const [mode, setMode] = useState(null);
    const [englishName, setEnglishName] = useState("");
    const [arabicName, setArabicName] = useState("");
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");



    const handleClose = () => {
        setMode(null);
        setEnglishName("");
        setArabicName("");
        setSelectedGroup(null);
        onClose?.();
    };

    // console.log("MoveProductsModal", selectedProducts);


    const handleSave = async () => {
        // Build payload for parent
        let payload = { selectedProducts: selectedProducts };

        if (mode === "new") {
            payload = {
                ...payload,
                englishName,
                arabicName,
            };
        } else if (mode === "existing") {
            payload = {
                ...payload,
                group_id: selectedGroup,
            };
        }

        // Call parent function
        if (onSave) {
            await onSave(payload);
        }

        handleClose();
    };


    if (!open) return null;

    return (
        <div
            className="fixed inset-0 z-[99] flex items-center justify-center"
            style={{
                backdropFilter: "blur(10px)",
                backgroundColor: "rgba(0,0,0,0.4)",
            }}
        >
            {/* Modal Box */}
            <div className="relative w-[650px] bg-white rounded-[20px] p-10 shadow-2xl z-[10000] animate-fadeIn">
                {/* Close Button */}
                <button
                    onClick={handleClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-black text-2xl font-semibold"
                >
                    ×
                </button>

                {/* Title */}
                <h2 className="text-3xl font-bold mb-8 text-gray-800">
                    {t("Move this into…")}
                </h2>

                {/* Options */}
                <div className="space-y-4 mb-8">
                    <div
                        onClick={() => {
                            setMode("new");
                            setSelectedGroup(null);
                        }} className={`p-4 rounded-2xl border-2 cursor-pointer transition font-semibold text-lg ${mode === "new"
                            ? "border-[#8DC63F] bg-green-50 text-gray-800"
                            : "border-gray-200 hover:bg-gray-50 text-gray-700"
                            }`}
                    >
                        {t("Create New Group")}
                    </div>

                    <div
                        onClick={() => setMode("existing")}
                        className={`p-4 rounded-2xl border-2 cursor-pointer transition font-semibold text-lg ${mode === "existing"
                            ? "border-[#8DC63F] bg-green-50 text-gray-800"
                            : "border-gray-200 hover:bg-gray-50 text-gray-700"
                            }`}
                    >
                        {t("Add to Existing Group")}
                    </div>
                </div>

                {/* Fields for Create New Group */}
                {mode === "new" && (
                    <div className="mb-8">
                        <h3 className="text-lg font-semibold mb-4 text-gray-600">
                            {t("Group Name")}
                        </h3>
                        <div className="grid grid-cols-2 gap-6">
                            <div>
                                <label className="block text-lg mb-2 font-medium text-gray-600">
                                    {t("English")}
                                </label>
                                <Input
                                    size="large"
                                    placeholder={t("Enter group name")}
                                    value={englishName}
                                    onChange={(e) => setEnglishName(e.target.value)}
                                    className="rounded-xl h-12 text-lg"
                                />
                            </div>
                            <div>
                                <label className="block text-lg mb-2 font-medium text-gray-600">
                                    {t("Arabic")}
                                </label>
                                <Input
                                    size="large"
                                    placeholder="أدخل اسم المجموعة"
                                    value={arabicName}
                                    onChange={(e) => setArabicName(e.target.value)}
                                    dir="rtl"
                                    className="rounded-xl h-12 text-lg"
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/* Fields for Existing Group */}
                {mode === "existing" && (
                    <div className="mb-8">
                        <h3 className="text-lg font-semibold mb-4 text-gray-600">
                            {t("Select Existing Group")}
                        </h3>
                        <Select
                            showSearch
                            placeholder={t("Search or select a group")}
                            value={selectedGroup}
                            onChange={(value) => setSelectedGroup(value)}
                            className="w-full text-lg h-12 z-[10000]"
                            size="large"
                            style={{ fontSize: "18px" }}
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {groups.map((g) => (
                                <Option className="text-lg"
                                    style={{ fontSize: "18px" }}
                                    key={g.id} value={g.id}>
                                    {g.name}
                                </Option>
                            ))}
                        </Select>
                    </div>
                )}


                {/* Done Button */}
                <Button
                    block
                    onClick={handleSave}
                    className="!h-14 !text-lg !font-semibold !rounded-2xl !bg-[#8DC63F] !text-white hover:!bg-[#7CB82F] focus:outline-none"
                    disabled={
                        (mode === "new" && (!englishName || !arabicName)) ||
                        (mode === "existing" && !selectedGroup) ||
                        (!mode)
                    }
                >
                    {t("Done")}
                </Button>
            </div>
        </div>
    );
};

export default MoveProductsModal;
